(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('markup-settings', {
            parent: 'entity',
            url: '/markup-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.markupSettings.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/markup-settings/markup-settings.html',
                    controller: 'MarkupSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('markupSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('markup-view', {
            parent: 'markup-settings',
            url: '/markup-settings/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/markup-settings/markup-settings-view-dialog.html',
                    controller: 'MarkupSettingsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['Markup', 'GlobalValues', function(Markup, GlobalValues) {
                                     return Markup.get({id : $stateParams.id}).$promise;
                                 }], 
                                 markupTypes: ['StaticLookUp', function(StaticLookUp){
                                	 return StaticLookUp.getMarkupTypes().$promise;
                                 }],
                                 roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                                    return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                                }]
                               
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('markup-new', {
            parent: 'markup-settings',
            url: '/new',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/markup-settings/markup-settings-dialog.html',
                    controller: 'MarkupSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            	                           	
                             
                            };
                        }, 
                        markupTypes: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('markup-edit', {
            parent: 'markup-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/markup-settings/markup-settings-dialog.html',
                    controller: 'MarkupSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['Markup', 'GlobalValues', function(Markup, GlobalValues) {
                                     return Markup.get({id : $stateParams.id}).$promise;
                                 }], 
                                 markupTypes: ['StaticLookUp', function(StaticLookUp){
                                	 return StaticLookUp.getMarkupTypes().$promise;
                                 }],
                                 roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                                    return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                                }]
                               
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('markup-todolist', {
            parent: 'dashboard',
            url: '/MarkupSettings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/markup-settings/markup-settings-view-dialog.html',
                    controller: 'MarkupSettingsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }, 
                        markupTypes: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('markup-settings', null, { reload: 'markup-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('markup-todolist.resubmit', {
            parent: 'dashboard',
            url: '/MarkupSettingsEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/markup-settings/markup-settings-dialog.html',
                    controller: 'MarkupSettingsEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }, 
                        markupTypes: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('markup-settings', null, { reload: 'markup-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('markup-auditLog', {
            parent: 'audit-log',
            url: '/MarkupSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/markup-settings/markup-settings-view-dialog.html',
                    controller: 'MarkupSettingsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }, 
                        markupTypes: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('markup-settings', null, { reload: 'markup-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('markup-historyReport', {
            parent: 'history-report',
            url: '/MarkupettingsHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/markup-settings/markup-settings-view-dialog.html',
                    controller: 'MarkupSettingsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }, 
                        markupTypes: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getMarkupTypes().$promise;
                        }],
                        roEdApplicabilityMethods: ['StaticLookUp', function(StaticLookUp){
                       	 return StaticLookUp.getRoEdApplicabilityMethodList().$promise;
                        }]
                    }
                }).result.then(function() {
                	$state.go('markup-settings', null, { reload: 'markup-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();
